import React from 'react';
import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';
const NavigationItems = (props) => {
return(
	<ul className = {classes.Navigationitems}>
		<NavigationItem link = '/' exact>Burger Builder</NavigationItem>
		{props.isAuthenticated?<NavigationItem link = '/orders'>Orders</NavigationItem>:null}
		{!props.isAuthenticated 
			?<NavigationItem link = '/auth'>Authenticate</NavigationItem>
			:<NavigationItem link = '/logout'>Logout</NavigationItem>}
	</ul>
)
}
export default NavigationItems 


// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js